import { render, staticRenderFns } from "./FormRecordingRequest.vue?vue&type=template&id=631ee2b1&scoped=true"
import script from "./FormRecordingRequest.vue?vue&type=script&lang=js"
export * from "./FormRecordingRequest.vue?vue&type=script&lang=js"
import style0 from "./FormRecordingRequest.vue?vue&type=style&index=0&id=631ee2b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631ee2b1",
  null
  
)

export default component.exports